export default "<mat-checkbox\n    [ngModel]=\"value\"\n    (ngModelChange)=\"onChange($event)\"\n></mat-checkbox>\n";